import { RoutePath } from '@/utils/lineStringToRoute';
import React from 'react';
import { Marker, Polyline } from 'react-leaflet';
import L from 'leaflet';

interface IProps {
  route: RoutePath;
  withStartMarker?: boolean;
  withEndMarker?: boolean;
}

const RouteMapLayer: React.FC<IProps> = ({
  route,
  withStartMarker = true,
  withEndMarker = true,
}) => (
  <>
    <Polyline positions={route.path} color="#3b82f6" weight={3} opacity={0.8} />

    {withStartMarker && (
      <Marker
        position={L.latLng(route.start.lat, route.start.lng)}
        icon={L.divIcon({
          iconSize: [16, 16],
          className:
            'rounded-full bg-green-500 border-2 border-white shadow-lg flex items-center justify-center',
          html: '<span class="w-full h-full"></span>',
        })}
        title="Ponto de partida"
      />
    )}

    {withEndMarker && (
      <Marker
        position={L.latLng(route.end.lat, route.end.lng)}
        icon={L.divIcon({
          iconSize: [16, 16],
          className:
            'rounded-full bg-red-500 border-2 border-white shadow-lg flex items-center justify-center',
          html: '<span class="w-full h-full"></span>',
        })}
        title="Ponto de chegada"
      />
    )}
  </>
);

export default RouteMapLayer;
